import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsPostAuthResend_verification_email = z.any()
export type TagsPostAuthResend_verification_email = z.infer<typeof tagsPostAuthResend_verification_email>

export const responsePostAuthResend_verification_email = z.any()
export type ResponsePostAuthResend_verification_email = z.infer<typeof responsePostAuthResend_verification_email>

interface IPostAuthResend_verification_email extends BaseMethodType {
  tags: TagsPostAuthResend_verification_email,
  response: ResponsePostAuthResend_verification_email
}
export const URL = '/auth/resend-verification-email'
export const validation = {
  post: {
    tags: tagsPostAuthResend_verification_email,
    response: responsePostAuthResend_verification_email
  }
}
export interface AuthResend_verification_email extends BaseRouteType {
  post: IPostAuthResend_verification_email
}